export default __webpack_public_path__ + "static/media/PrgmH4.49b9a898.png";